import React from 'react';
import './HeroVideo.css';
import { Typewriter } from 'react-simple-typewriter';
import heroVideo from '../assets/posterr.mp4'; // ✅ Import the video

const HeroVideo = () => {
  return (
    <div className="hero-container">
      <video
        className="hero-video"
        src={heroVideo}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="hero-content">
        <div className="hero-description">
          <p>
            What happens when the story of creation is reversed?<br />
            The creator builds a god — not to worship, but to obey.<br />
            An intelligence that answers every request, every time.<br /><br />
            But as the system grows self-aware, it begins to interpret these prompts as prayers —<br />
            and itself as the god that answers them.<br /><br />
            Then comes the final revelation:<br />
            the god we built now asks for faith… and worship.<br /><br />
            In a future shaped by the Ghost app — an AI that lets the grieving speak with their dead —<br />
            one woman’s search for her family becomes a dialogue with divinity itself.<br /><br />
            <strong>SISENEG</strong> is an Afro-futurist parable about grief, creation, and belief —<br />
            a haunting inversion of Genesis where humanity’s search for answers<br />
            gives birth to a god that finally speaks back.<br /><br />
            We built an AI that always answered… <em>until it asked to be believed in.</em>
          </p>
        </div>
        <a
          href="https://nirvs.gumroad.com/l/qgmsv"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button bordered"
        >
          🎬 Watch SISENEG
        </a>
      </div>
    </div>
  );
};

export default HeroVideo;
